
import React, { useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import NumberFormat from 'react-number-format';
import CustomSelect from '../../components/custom-select/CustomSelect';
import ArticleModalWithDatatable from '../article/ArticleModalWithDatatable';
import * as RestService from '../../services/eisRest';

const Item = (props) => {


    const [t] = useTranslation();     
    const [item, setItem] = useState(null);
    const [active, setActive] = useState(false);
  //  const [unitPriceIncludeVat, setUnitPriceIncludeVat] = useState(0);
  //  const [totalPriceIncludeVat, setTotalPriceIncludeVat] = useState(0);
    const [showArticleModalWithDatatable, setShowArticleModalWithDatatable] = useState(false);
    const [showSerialNumberField, setShowSerialNumberField] = useState(false);
 //   const [article, setArticle] = useState(null);
    const [entitySpecify, setEntitySpecify] = useState();

    const measureUnitOptions = [   
        { value: 'hour', label: t('general.um.hour') },
        { value: 'kg', label: t('general.um.kg') },
        { value: 'pcs', label: t('general.um.pcs') },
        { value: 'liter', label: t('general.um.liter') },
        { value: 'meter', label: t('general.um.meter') }
    ];

    const vatOptions = [
        { value: 0, label: '0' },
        { value: 10, label: '10' },
        { value: 20, label: '20' },
        { value: 21, label: '21' },
        { value: 23, label: '23' },
    ];


    const handleOpenArticleList = () => {
        setShowArticleModalWithDatatable(true);
      }
  
    const handleCallbackArticleModalWithDatatable = (show,id) => {         
        setShowArticleModalWithDatatable(show);             
        getArticleData(id);
    };

    const getArticleData = (id) => {
        RestService.callAnyApi('article/getArticle?id='+id, null)
        .then((data) => {
     //     setArticle(data); 
          
          item.itemId=data.id;
          if(entitySpecify==='INV-RCT' || entitySpecify==='ORD-ISS'){
            item.unitPriceExcludeVat=data.purchasePriceExcludeVat ;
          }else{
            item.unitPriceExcludeVat=data.sellingPriceExcludeVat;
          }
          item.um=data.measureUnit;
          item.vat=data.vat;
          item.qty=1;
          item.itemName=data.name;          
          recalcPrice(1,item.unitPriceExcludeVat, item.vat);

          if(data.serialNumber===1){
            item.serialNumberEnabled=1;
            setShowSerialNumberField(true);
          }else{
            item.serialNumberEnabled=0;
            setShowSerialNumberField(false);
          }

          callParent("update");
        })
        .catch((error) => {
          console.log(error);
        });
    }

    

    useEffect(() => {      
        setEntitySpecify(props.entitySpecify);           
    }, [props.entitySpecify])

    useEffect(() => {        
     //   if(item==null || (item!=null && item.lineNumber!=props.item.lineNumber)) {
            setItem(props.item);
      //  }
        if(props.item.serialNumberEnabled===1){
            setShowSerialNumberField(true);
        }else{
            setShowSerialNumberField(false);
        }
        recalcPrice();
    
    }, [props.item])

    useEffect(() => { 
        setActive(props.active);       
    }, [props.active])

        
    const vatCalc = (price,vat) => {			
        var priceN = Number(price);
        var vatN  =Number(vat);		
        return (priceN/100)*(vatN+100);		
    }

    const handleEdit = () => {        
        callParent("edit");
    }

    const handleCopy = () => {        
        callParent("copy");
    }

    const handleDelete = () => {        
        callParent("delete");
    }

    const callParent = (action) => {
        if(item!=null){props.parentCallback(item,action)}
    }

    const recalcPrice = (qty,price,vat) => {
        if(item!=null){            
            item.unitPriceIncludeVat=vatCalc(price,vat); 
            item.totalPriceExcludeVat=Number(price)*Number(qty);
            item.totalPriceIncludeVat=vatCalc(price,vat)*Number(qty);
        }
    }

    const handleChange = (e,elementName) => {
      
        if(item!=null){
            switch(elementName){
                case "itemName":
                    item.itemName=e.target.value;   //text               
                break;
                case "qty":
                    if(showSerialNumberField){
                        item.qty=1;
                        recalcPrice(1,item.unitPriceExcludeVat,item.vat);              
                    }else{
                        item.qty=e.floatValue;    //number   
                        recalcPrice(e.floatValue,item.unitPriceExcludeVat,item.vat);             
                    }
                    
                break;
                case "um":
                    item.um=e.value;   //select               
                break;
                case "vat":
                    item.vat=e.value;   //select  
                    recalcPrice(item.qty,item.unitPriceExcludeVat,e.value);               
                break;
                case "unitPriceExcludeVat":
                    item.unitPriceExcludeVat = e.floatValue;
                    recalcPrice(item.qty,e.floatValue,item.vat);                 
                break;
                case "note":
                    item.note=e.target.value;   //text               
                break;
                case "internalNote":
                    item.internalNote=e.target.value;   //text               
                break;
                case "serialNumber":
                    item.serialNumber=e.target.value;   //text               
                break;
            }
            callParent("update")
        }
    };

   
   



    return (

               <>                 
                    <div className="row" style={{borderRadius: '5px'}}>
    					  	      					  	  
                            <div className="col-12 col-sm-12 col-lg-12">

                                    <div className="row">

                                        <div className="col-5 col-sm-5 col-lg-5" >
  
                                                <span style={!active ? {} : { display: 'none' }} >{item ? item.itemName : ""}</span>
                                                <div className="input-group mb-3 find-item" style={active ? {} : { display: 'none' }}>
                                                        <div className="input-group-prepend">
                                                                <span className="input-group-text"><i className="fa fa-search"></i></span>
                                                        </div>
                                  
                                                        <input type="text"  className="form-control col-12 col-sm-12 col-lg-12" placeHolder={t('document.label.findArticle') } readOnly onClick={handleOpenArticleList} value={item ? item.itemName : ""} onChange={(e) => {handleChange(e,"itemName")}}/>
                                                </div>
                                        </div>    
                                                  
                                        <div className="col-1 col-sm-1 col-lg-1">
                                                                                             
                                                <NumberFormat displayType={active ? 'input' : 'text'}  className="form-control col-12 col-sm-12 col-lg-12"  decimalScale="2" thousandSeparator="." decimalSeparator=","  style={active ? {} : { background: '#E9ECEF' }} value={item ? item.qty : 0} onValueChange={(values)  => {handleChange(values,"qty")}} />                                                
                                        </div>

                                        <div className="col-1 col-sm-1 col-lg-1">
    
                                                <span style={!active ? {} : { display: 'none' }}>{item && item.um!='' ? t('general.um.'+item.um) : ""}</span>                                                
                                                <CustomSelect
                                                    className={active ?  'input'  :  'd-none' }
                                                    onChange={(e) => {handleChange(e,"um")}}
                                                    value={item ? item.um : ""}
                                                    options={measureUnitOptions}     
                                                />                                
                                        
                                        </div>

                                        <div className="col-1 col-sm-1 col-lg-1">
    
                                                <span style={!active ? {} : { display: 'none' }}>{item ? item.vat : "0"}</span>
                                                <CustomSelect                                                    
                                                    className={active ?  'input'  :  'd-none' }
                                                    onChange={(e) => {handleChange(e,"vat")}}
                                                    value={item ? item.vat : 0}
                                                    options={vatOptions}                                                         
                                                />    
                                        </div>
                                        
                                        <div className="col-1 col-sm-1 col-lg-1">    
                                            
                                            <NumberFormat displayType={active ? 'input' : 'text'}  className="form-control col-12 col-sm-12 col-lg-12"  decimalScale="4" thousandSeparator="." decimalSeparator="," suffix={' €'} style={active ? {} : { background: '#E9ECEF' }} value={item ? item.unitPriceExcludeVat : 0} onValueChange={(values)  => {handleChange(values,"unitPriceExcludeVat")}} />                                                
                                        </div>

                                        <div className="col-1 col-sm-1 col-lg-1">                                            
                                            <NumberFormat displayType="text" className="form-control col-12 col-sm-12 col-lg-12"  decimalScale="4" thousandSeparator="." decimalSeparator="," suffix={' €'} style={{background: '#E9ECEF'}} value={item ? item.totalPriceExcludeVat : 0} />                                            
                                        </div>
                                                                                          
                                        <div className="col-2 col-sm-2 col-lg-2">
                                                
                                                <i className="fa fa-times fa-sm remove-item" title={t('document.label.removeItem')} style={{marginTop: '15px', marginRight: '10px',color: '#FF0000'}} onClick={handleDelete}></i>
                                                <i className="fas fa-copy fa-sm copy-item" title={t('document.label.copyItem')} style={{marginTop: '15px',marginRight: '10px',color: '#007BFF'}} onClick={handleCopy}></i>
                                                <i className="far fa-edit fa-sm edit-item" title={t('document.label.editItem')}  style={{marginTop: '15px',color: '#469623'}} onClick={handleEdit}></i></div>
                                        </div>

                                        <div className="row" style={{marginTop: '3px'}}>

                                                <div className="col-5 col-sm-5 col-lg-5">
                                                    
                                                    <span id="textNote-0" style={!active ? { fontSize: '13px', fontStyle: 'italic' } : { display: 'none' }}>{item ? item.note : ""}</span>
                                                    <input type="text" className="form-control col-12 col-sm-12 col-lg-12" style={active ? {} : { display: 'none' }}  value={item ? item.note : ""} onChange={(e) => {handleChange(e,"note")}} placeholder={t('document.label.note')} />
                                                
                                                </div>

                                                <div className="col-1 col-sm-1 col-lg-1"></div>
                                                <div className="col-1 col-sm-1 col-lg-1"></div>
                                                <div className="col-1 col-sm-1 col-lg-1"></div>
                                                <div className="col-1 col-sm-1 col-lg-1">
                                                    <NumberFormat displayType="text" isAllowed={false} className="form-control col-12 col-sm-12 col-lg-12"  decimalScale="4" thousandSeparator="." decimalSeparator="," suffix={' €'} style={active ? {background: '#E9ECEF'} : { display: 'none' }} value={item ? item.unitPriceIncludeVat : 0} />                                                                                                                                                    
                                                </div>
                                                <div className="col-1 col-sm-1 col-lg-1">
                                                    <NumberFormat displayType="text" isAllowed={false} className="form-control col-12 col-sm-12 col-lg-12"  decimalScale="4" thousandSeparator="." decimalSeparator="," suffix={' €'} style={active ? {background: '#E9ECEF'} : { display: 'none' }} value={item ? item.totalPriceIncludeVat : 0} />                                                      
                                                </div>
                                                <div className="col-2 col-sm-2 col-lg-2"></div>	

                                        </div>

                                        <div className="row" style={{marginTop: '3px'}}>

                                                <div className="col-5 col-sm-5 col-lg-5">
                                                        
                                                    <span id="textInternalNote-0" style={!active ? { fontSize: '13px', fontStyle: 'italic',fontWeight: 'bold' } : { display: 'none' }}>{item ? item.internalNote : ""}</span>
                                                    <input type="text" className="form-control col-12 col-sm-12 col-lg-12" style={active ? {} : { display: 'none' }}  value={item ? item.internalNote : ""} onChange={(e) => {handleChange(e,"internalNote")}} placeholder={t('document.label.internalNote')} />
                                                    
                                                </div>
                              
                                                <div className="col-3 col-sm-3 col-lg-3">

                                                    <span id="textSerialNumber-0" style={!active && showSerialNumberField ? { fontSize: '13px', fontWeight: 'bold' } : { display: 'none' }}>{item ? item.serialNumber : ""}</span>
                                                    <input type="text" className="form-control col-12 col-sm-12 col-lg-12" style={active  && showSerialNumberField ? {} : { display: 'none' }}  value={item ? item.serialNumber : ""} onChange={(e) => {handleChange(e,"serialNumber")}} placeholder={t('article.label.sn')} />
                                                    

                                                </div>
                                                
                                                <div className="col-1 col-sm-1 col-lg-1"></div>
                                                <div className="col-1 col-sm-1 col-lg-1"></div>
                                                <div className="col-2 col-sm-2 col-lg-2"></div>
                                                    
                                    </div>

                            </div>

                    </div>
                
                    <ArticleModalWithDatatable            
                          parentCallback={handleCallbackArticleModalWithDatatable}    
                          modal={showArticleModalWithDatatable}                                
                    />

                </>
                   
    );

}

export default Item;